import React from 'react'

type ErrorBoundaryProps = {
    children: React.ReactNode
}

type ErrorBoundaryState = {
    hasError: boolean
    errorMessage: string
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = { hasError: false, errorMessage: '' }
    }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true, errorMessage: '' }
    }

    componentDidCatch(error: Error) {
        this.setState({ errorMessage: error?.message || 'Unknown render error' })
    }

    render() {
        if (this.state.hasError) {
            const isDevelopment = process.env.NODE_ENV !== 'production'

            return (
                <div style={{ color: '#E6001E', padding: '16px 20px', fontWeight: 700 }}>
                    <div>Service unavailable. Please refresh and try again.</div>
                    {isDevelopment && this.state.errorMessage ? (
                        <div style={{ marginTop: 8, fontWeight: 500, fontSize: 12 }}>
                            {this.state.errorMessage}
                        </div>
                    ) : null}
                </div>
            )
        }

        return this.props.children
    }
}
